import { render, staticRenderFns } from "./vegas.vue?vue&type=template&id=2fe2abd2"
import script from "./vegas.vue?vue&type=script&lang=js"
export * from "./vegas.vue?vue&type=script&lang=js"
import style0 from "./vegas.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/vegas.vue
// module id = i3H4
// module chunks = 0